import React from 'react'
import PropTypes from 'prop-types'
import PortfolioDonut from '../PortfolioDonut/PortfolioDonut'
import AssetClassBreakdown from '../AssetClassBreakdown/AssetClassBreakdown'
import styles from './PortfolioOverview.module.scss'
import Link from 'redux-first-router-link'
import classnames from 'classnames'

class PortfolioOverview extends React.Component {

  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    const {
      primaryPortfolio: {
        classAllocations,
      },
      showLinkToPortfolioPage,
      isMobile
    } = this.props

    const mobileLinkClasses = classnames('button', 'button--secondary', styles.portfolioLink)
    const linkClasses = isMobile ? mobileLinkClasses : styles.portfolioLink
    return (
      <div className={styles.PortfolioOverview}>
        <p className={styles.title}>Asset Allocation</p>
        <div className={styles.portfolioOverviewWrapper}>
          <PortfolioDonut
            model={classAllocations}
            width={200}
            height={195}
            innerRadius={40} />
          <div>
            <AssetClassBreakdown
              ownClasses={styles.assetClassBreakdown}
              model={classAllocations} />
            {showLinkToPortfolioPage && <Link to="/portfolio" className={linkClasses}>View Details</Link>}
          </div>
        </div>
      </div>
    )
  }

}
PortfolioOverview.defaultProps = {
  primaryPortfolio: {},
  isMobile: false,
  showLinkToPortfolioPage: false
}

PortfolioOverview.propTypes = {
  primaryPortfolio: PropTypes.object,
  isMobile: PropTypes.bool,
  showLinkToPortfolioPage: PropTypes.bool
}

export default PortfolioOverview



// WEBPACK FOOTER //
// ./src/components/Client/PortfolioOverview/PortfolioOverview.jsx